import { createServiceClient, type ServiceClient } from './http/client';
import { SERVICES, type ServiceName } from './services';

/**
 * 서버별 요청 함수 — `api.core.get<Booking[]>('admin/bookings', { params, signal })`.
 * 화면별 API 함수·queryOptions는 `src/api/<서버>/<도메인>.ts`에 두고 여기서 고른 클라이언트만 쓴다.
 */
export const api = Object.fromEntries(
  Object.entries(SERVICES).map(([name, def]) => [name, createServiceClient(name, def)]),
) as Record<ServiceName, ServiceClient>;

export type { RequestOptions, ServiceClient } from './http/client';
export { ApiError, isApiError, isNetworkError } from './http/errors';
